/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {COLORS} from "@res/colors";

type Props = {
	text: string
}

export class GreenTitle
	extends React.Component<Props> {

	render() {
		return <div style={{fontWeight: 500, color: COLORS.systemGreen, paddingRight: 5}}>
			{this.props.text}
		</div>;
	}

}
